<template>
  <div class="login Kanit">
    <v-layout row wrap style="height: 100vh; padding: 25px 30px; overflow: scroll;">
      <v-flex xs12 sm12 md12 lg12 xl12 style="background: white;" v-if="progress">
        <div style="height: 100%;display: flex;">
        <v-progress-circular
        :size="150"
        color="primary"
        indeterminate
        :width="7"
        style="margin: auto;"
      ></v-progress-circular>
    </div>
      </v-flex>
      <v-flex xs12 sm12 md12 lg12 xl12 style="background: white;" v-else-if="point==''">
        <h3>แบบทดสอบความรู้ {{typetest=='pretest'? 'ก่อนบทเรียน':'หลังบทเรียน'}}</h3>
        <h3>ด้านการทำ CPR และการใช้งานเครื่อง AED</h3>
        <div class="headerQuestion">
          <span style="text-decoration: underline;">ส่วนที่ 1: ข้อมูลพื้นฐาน</span>
          <br/>
          <div class="QuestionanswerChoice" v-for="(iteminformation,indexinformation) in informationList">
            <span>{{iteminformation.question_text}} <span style="color: red;">*</span></span>
            <v-radio-group v-model="answer_paper[indexinformation]" class="answerGroup">
              <v-radio :label="item.answer_text" :value="item" v-for="(item,index) in iteminformation.choice"></v-radio>
            </v-radio-group>
          </div>
        </div>
        <!-- ส่วนที่ 2 -->
        <div class="headerQuestion">
          <span style="text-decoration: underline;">ส่วนที่ 2: ความรู้พื้นฐานการช่วยฟื้นคืนชีพ CPR</span>
          <br/>
          <div class="QuestionanswerChoice" v-for="(itemQuestion,indexQuestion) in questionList">
            <span>{{itemQuestion.question_text}} <span style="color: red;">*</span></span>
            <v-radio-group v-model="answer_paper[indexQuestion + 5]" class="answerGroup">
              <v-radio :label="item.answer_text" :value="item" v-for="(item,index) in itemQuestion.choice"></v-radio>
            </v-radio-group>
          </div>
        </div>
        <v-btn class="submitBTN" :disabled="statusBTN_submit" @click="sendExamination()"> ส่งคำตอบ</v-btn>
      </v-flex>
      <v-flex xs12 sm12 md12 lg12 xl12 style="background: white;" v-else>
      <div style="margin-top: 20vh;">
        <h3>แบบทดสอบความรู้ {{typetest=='pretest'? 'ก่อนบทเรียน':'หลังบทเรียน'}} </h3>
        <img :src="BASE_URL + 'static/examination/score.svg'" style="height: 15vh;margin-top: 30px;" />
        <h3 style="margin-top: 10px;">ท่านได้คะแนน: <span :style="(parseInt(point) < 6)? {color: 'red'}:{color: '#24b913'}">{{point}}</span>/10 </h3>
        <v-btn @click="gotoNext()" class="nextBTN"> {{typetest=='pretest'? 'เริ่มบทเรียน':'คู่มืออาสาสมัคร'}} </v-btn>
      </div>
    </v-flex>
    </v-layout>
    
  </div>
</template>





<script>
import { Encode, Decode } from '@/services'
export default {
  data () {
    return {
      BASE_URL: process.env.BASE_URL,
      typetest: '',
      user_id: '',
      answer_paper: [],
      informationList: [
        {
          question_text: '1. อายุของท่าน',
          choice: [
            {question_id: '1.1', answer_id: '0',answer_text: '20-30'},
            {question_id: '1.1', answer_id: '1',answer_text: '31-40'},
            {question_id: '1.1', answer_id: '2',answer_text: '41-50'},
            {question_id: '1.1', answer_id: '3',answer_text: '51-60'},
            {question_id: '1.1', answer_id: '4',answer_text: 'มากกว่า60'}
          ]
        },
        {
          question_text: '2. เพศ',
          choice: [
              {question_id: '1.2', answer_id: '0', answer_text: 'ชาย'},
              {question_id: '1.2', answer_id: '1', answer_text: 'หญิง'},
              {question_id: '1.2', answer_id: '2', answer_text: 'เพศทางเลือก'}
          ]
        },
        {
          question_text: '3. ท่านเคยอบรม การช่วยกู้ฟื้นคืนชีพหรือไม่',
          choice: [
              {question_id: '1.3', answer_id: '0', answer_text: 'เคยอบรม'},
              {question_id: '1.3', answer_id: '1', answer_text: 'ไม่เคยอบรม'}
          ]
        },
        {
          question_text: '4. ท่านมีความมั่นใจในความสามารถของท่านในการเข้าไปช่วยฟื้นคืนชีพมากน้อยเพียงใด',
          choice: [
              {question_id: '1.4', answer_id: '0', answer_text: 'ไม่มั่นใจ'},
              {question_id: '1.4', answer_id: '1', answer_text: 'อาจจะทำได้บ้าง'},
              {question_id: '1.4', answer_id: '2', answer_text: 'คาดว่าน่าจะทำได้ระดับหนึ่ง'},
              {question_id: '1.4', answer_id: '3', answer_text: 'มีความมั่นใจมาก'}
          ]
        },
        {
          question_text: '5. หากท่านพบผู้ป่วยต้องการการช่วยฟื้นคืนชีพ CPR ท่านกล้าเข้าไปช่วย CPR มากน้อยเพียงใด',
          choice: [
              {question_id: '1.5', answer_id: '0', answer_text: 'ไม่เข้าไปช่วย CPR แน่นอน'},
              {question_id: '1.5', answer_id: '1', answer_text: 'น่าจะไม่เข้าไปช่วย'},
              {question_id: '1.5', answer_id: '2', answer_text: 'น่าจะเข้าไปช่วย'},
              {question_id: '1.5', answer_id: '3', answer_text: 'เข้าไปช่วยอย่างแน่นอน'}
          ]
        }
      ],
      questionList: [
        {
          question_text: '1. ลำดับขั้นตอนการช่วยฟื้นคืนชีพ เมื่อพบคนหมดสติ ไม่หายใจ',
          choice: [
            {question_id: '2.1', answer_id: '0', answer_text: 'ปลุกเรียก, call for help, กดหน้าอก, ใช้เครื่อง AED'},
            {question_id: '2.1', answer_id: '1', answer_text: 'call for help, ปลุกเรียก, กดหน้าอก, ใช้เครื่อง AED'},
            {question_id: '2.1', answer_id: '2', answer_text: 'call for help, ปลุกเรียก, คลำชีพจร, กดหน้าอก, ใช้เครื่อง AED'},
            {question_id: '2.1', answer_id: '3', answer_text: 'ปลุกเรียก, call for help, คลำชีพจร, กดหน้าอก, ใช้เครื่อง AED'}
          ]
        },
        {
          question_text: '2. สิ่งแรกที่ต้องทำเมื่อพบผู้ป่วยต้องการการช่วยฟื้นคืนชีพ คือ',
          choice: [
            {question_id: '2.2', answer_id: '0', answer_text: 'โทรเรียกรถพยาบาล'},
            {question_id: '2.2', answer_id: '1', answer_text: 'กดหน้าอกทันที'},
            {question_id: '2.2', answer_id: '2', answer_text: 'ดูว่าปลอดภัยที่เข้าช่วยเหลือหรือไม่'},
            {question_id: '2.2', answer_id: '3', answer_text: 'ตะโกนขอความช่วยเหลือ และขอ AED'}
          ]
        },
        {
          question_text: '3. ท่านกำลังช่วยกดหน้าอก (CPR) อยู่ แล้วเครื่องกระตุกหัวใจอัตโนมัติ (AED) มาถึงควรใช้เมื่อไหร่',
          choice: [
            {question_id: '2.3', answer_id: '0', answer_text: 'หลังการกดหน้าอกไปแล้ว 2 นาที'},
            {question_id: '2.3', answer_id: '1', answer_text: 'หลังการกดหน้าอกไปแล้ว 200 ครั้ง'},
            {question_id: '2.3', answer_id: '2', answer_text: 'ทันทีที่เครื่อง AED มาถึง'},
            {question_id: '2.3', answer_id: '3', answer_text: 'เมื่อเจ้าหน้าที่กู้ชีพมาถึง'}
          ]
        },
        {
          question_text: '4. การกดหน้าอกด้วยอัตราเร็วเท่าไหร่ได้ประสิทธิภาพดีที่สุด',
          choice: [
            {question_id: '2.4', answer_id: '0', answer_text: '80 ครั้งต่อนาที'},
            {question_id: '2.4', answer_id: '1', answer_text: '80-100 ครั้งต่อนาที'},
            {question_id: '2.4', answer_id: '2', answer_text: '100-120 ครั้งต่อนาที'},
            {question_id: '2.4', answer_id: '3', answer_text: 'เร็วที่สุดเท่าที่ทำได้'}
          ]
        },
        {
          question_text: '5. เพื่อให้การช่วยฟื้นคืนชีพผู้ป่วยหัวใจหยุดเต้นฉับพลันได้ผลดีที่สุด ไม่แนะนำให้หยุดกดหน้าอกนานกว่าเวลาเท่าใด',
          choice: [
            {question_id: '2.5', answer_id: '0', answer_text: 'ไม่เกิน 10 วินาที'},
            {question_id: '2.5', answer_id: '1', answer_text: 'ไม่เกิน 30 วินาที'},
            {question_id: '2.5', answer_id: '2', answer_text: 'ไม่เกิน 1 นาที'},
            {question_id: '2.5', answer_id: '3', answer_text: 'ไม่เกิน 2 นาที'}
          ]
        },
        {
          question_text: '6. การกดหน้าอกช่วยฟื้นคืนชีพอย่างมีประสิทธิภาพ ยกเว้น',
          choice: [
            {question_id: '2.6', answer_id: '0',answer_text: 'กดลึก 5 ซม.'},
            {question_id: '2.6', answer_id: '1',answer_text: 'ปล่อยสุด'},
            {question_id: '2.6', answer_id: '2',answer_text: 'เปลี่ยนผู้ช่วยกดหน้าอกทุก 2 นาที'},
            {question_id: '2.6', answer_id: '3',answer_text: 'กดด้านซ้ายของหน้าอกที่ตำแหน่งหัวใจ'}
          ]
        },
        {
          question_text: '7. ผู้ใดบ้างที่สามารถใช้เครื่องกระตุกหัวใจอัตโนมัติ (AED) ได้',
          choice: [
            {question_id: '2.7', answer_id: '0', answer_text: 'บุคลากรทางการแพทย์เท่านั้น'},
            {question_id: '2.7', answer_id: '1', answer_text: 'ประชาชนที่ผ่านการฝึกอบรม'},
            {question_id: '2.7', answer_id: '2', answer_text: 'อสม.'},
            {question_id: '2.7', answer_id: '3', answer_text: 'ประชาชนทั่วไปแม้ไม่ผ่านการฝึกมาก่อน'}
          ]
        },
        {
          question_text: '8. ขั้นตอนการใช้ AED ที่เหมาะสมที่สุด',
          choice: [
            {question_id: '2.8', answer_id: '0', answer_text: 'แปะแผ่นกับตัวผู้ป่วย เปิดเครื่อง วิเคราะห์ และกดหน้าอก'},
            {question_id: '2.8', answer_id: '1', answer_text: 'เปิดเครื่อง แปะแผ่นกับตัวผู้ป่วย วิเคราะห์ และกดปุ่ม shock ตามเครื่องแนะนำ'},
            {question_id: '2.8', answer_id: '2', answer_text: 'เปิดเครื่อง แปะแผ่นกับตัวผู้ป่วย กดหน้าอกระหว่างวิเคราะห์ และกดปุ่ม shock ตามเครื่องแนะนำ'},
            {question_id: '2.8', answer_id: '3', answer_text: 'แปะแผ่นกับตัวผู้ป่วย เปิดเครื่อง วิเคราะห์ และกดปุ่ม shock ตามเครื่องแนะนำ'}
          ]
        },
        {
          question_text: '9. ข้อใดกล่าวถูกต้อง เมื่อเครื่อง AED แนะนำให้กดปุ่ม Shock ไฟฟ้าหัวใจ',
          choice: [
            {question_id: '2.9', answer_id: '0', answer_text: 'กดปุ่ม shock ทันที'},
            {question_id: '2.9', answer_id: '1', answer_text: 'โทรตามทีมแพทย์ให้รีบมา'},
            {question_id: '2.9', answer_id: '2', answer_text: 'ตรวจสอบว่าไม่มีใครสัมผัสผู้ป่วย และกดปุ่ม shock'},
            {question_id: '2.9', answer_id: '3', answer_text: 'กดหน้าอกต่อเนื่องในความเร็วที่เหมาะสม'}
          ]
        },
        {
          question_text: '10. เราควรหยุดช่วยฟื้นคืนชีพผู้ป่วยเมื่อใด',
          choice: [
            {question_id: '2.10', answer_id: '0', answer_text: 'รถพยาบาลกู้ชีพมาถึงและส่งต่อผู้ป่วยให้ทีมกู้ชีพ'},
            {question_id: '2.10', answer_id: '1', answer_text: 'ผู้ป่วยฟื้นคืนสติ'},
            {question_id: '2.10', answer_id: '2', answer_text: 'สถานการณ์ไม่ปลอดภัยต่อผู้ช่วยเหลือ'},
            {question_id: '2.10', answer_id: '3', answer_text: 'ถูกทุกข้อ'}
          ]
        }
      ],
      is_answer: '',
      point: '',
      progress: false
    }
  },
  created () {
    this.typetest = this.$route.query.typetest
    this.user_id = this.$route.query.user_id
    this.checkStatustest()
  },
  components: {  },
  computed: {
    statusBTN_submit () {
      // console.log(this.information)
      if (this.answer_paper.length == 15) {
        if (!this.answer_paper.includes(undefined)) {
          return false
        }
      }
      return true
    }
  },
  methods: {
    checkStatustest () {
      this.progress = true
      var body = {"userid": this.user_id}
      this.axios.post(process.env.API_BACKEND + '/v1/checkStatusExam', body).then((response) => {
        // console.log(response.data[this.typetest].is_answer)
        this.progress = false
        if (response.data[this.typetest].is_answer == 'true') {
          this.point = response.data[this.typetest].point
        }
        if (this.typetest == 'posttest' && (response.data['pretest'].is_answer == 'false')) {
        // if (true) {
          this.$swal({
            title: '',
            text: 'ท่านยังไม่ได้ทำแบบทดสอบก่อนเริ่มบทเรียน กรุณากลับไปทำแบบทดสอบ',
            type: 'warning',
            confirmButtonColor: '#d33',
            confirmButtonText: 'ตกลง',
            confirmButtonClass: 'btn btn-success',
            showCloseButton: true,
          }).then((result) => {
            if (result.value) {
              this.typetest = 'pretest'
              this.point = ''
            }
          })
        }
      })
    },
    gotoNext () {
      var body = {
        "userid": this.user_id,
        "type": this.typetest
      }
      this.axios.post(process.env.API_BACKEND + '/v1/finishExam', body).then((response) => {
      })
    },
    sendExamination () {
      this.progress = true
      var body = {
        "userid": this.user_id,
        "type": this.typetest,
        "answer_paper": this.answer_paper
      }
      this.axios.post(process.env.API_BACKEND + '/v1/sendAnswer', body).then((response) => {
        // console.log(response.data.point)
        this.progress = false
        if (response.data.status === 200) {
          this.point = response.data.point + ''
          // console.log(this.point=='')
        }
        //   this.$swal( 'สำเร็จ', 'แก้ไขข้อมูล' + this.textType_company + 'สำเร็จแล้ว' , 'success' )
        //   this.closeDialog(true)
        // } else {
        //   this.$swal( 'ไม่สำเร็จ', 'แก้ไขข้อมูล' + this.textType_company + 'ไม่สำเร็จแล้ว', 'error' )
        //   this.closeDialog(false)
        // }
      })
    }
  }
}
</script>
<style scoped>
.Kanit{
  font-family: 'Kanit', sans-serif !important;
}
h1, h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
.vertical-center {
  margin: 0;
  position: absolute;
  top: 50%;
  -ms-transform: translateY(-50%);
  transform: translateY(-50%);
}
.horizontal-center {
  margin-left: auto;
  margin-right: auto;
}
.text-field {
   width: 50%;
}
.text-field label{
  background: white !important;
}
.text-field .v-input__slot{
  background: white !important;
}
>>>.theme--light.v-icon {
  color: rgb(170, 8, 0) !important;
  caret-color: rgb(170, 8, 0) !important;
}
>>>.primary--text {
  color: rgb(170, 8, 0) !important;
  caret-color: rgb(170, 8, 0) !important;
  }
>>>.text-field:focus .theme--light.v-icon {
  color: white !important;
}

>>>.theme--light.v-text-field--outline>.v-input__control>.v-input__slot {
    border: 2px solid white;
    border-radius: 50px;
    background: white !important;
}
>>>.theme--light.v-text-field--outline>.v-input__control>.v-input__slot:hover {
    border: 2px solid white;
}
>>>.v-input--selection-controls {
    margin-top: 0 !important;
    }

.headerQuestion {
  margin-top: 30px;
  text-align: left;
  color: black;
}
.QuestionanswerChoice {
  margin-top: 10px;
  text-align: left;
  padding-left: 15px;
  color: black;
}
.answerGroup {
  margin-left: 10px;
}
>>>.v-input--selection-controls .v-radio>.v-label {
  color: black !important;
  }
.submitBTN {
    background: rgb(170, 8, 0) !important;
    color: white !important;
    border-radius: 20px;
    box-shadow: none;
    margin-top: 10px;
}
.nextBTN {
      margin-top: 20px;
    box-shadow: none;
    background: #a793c5 !important;
    color: white !important;
}
</style>



// WEBPACK FOOTER //
// src/components/test/examination.vue